import Card, { CardHeader, CardContent } from "@/components/shared/ui/Card";
import Button from "@/components/shared/ui/Button";

interface ProjectMetric {
  label: string;
  value: string;
  progress?: number;
}

interface ProjectSidebarProps {
  metrics: ProjectMetric[];
  adminNote?: string;
  lastUpdated?: string;
  showFundingProgress?: boolean;
  onRequestMeeting?: () => void;
  onAskQuestion?: () => void;
}

export default function ProjectSidebar({
  metrics,
  adminNote,
  lastUpdated,
  showFundingProgress = true,
  onRequestMeeting,
  onAskQuestion,
}: ProjectSidebarProps) {
  return (
    <div className="space-y-4 sm:space-y-6">
      {/* Key Metrics Card */}
      <Card variant="bordered">
        <CardHeader color="pink">
          <h3 className="text-base sm:text-lg font-bold text-black">
            Key Metrics
          </h3>
        </CardHeader>
        <CardContent>
          <div className="space-y-3 sm:space-y-4">
            {metrics.map((metric, index) => (
              <div key={index}>
                <div className="flex justify-between mb-2">
                  <span className="text-xs sm:text-sm text-gray-600">
                    {metric.label}
                  </span>
                  <span className="text-xs sm:text-sm font-bold text-black">
                    {metric.value}
                  </span>
                </div>
                {metric.progress !== undefined && showFundingProgress && (
                  <div className="w-full bg-gray-200 h-2 rounded-full overflow-hidden">
                    <div
                      className="bg-gradient-to-r from-green-400 to-green-600 h-full transition-all duration-300"
                      style={{ width: `${metric.progress}%` }}
                    />
                  </div>
                )}
              </div>
            ))}
          </div>
        </CardContent>
      </Card>

      {/* Admin Note Card */}
      {adminNote && (
        <Card variant="bordered">
          <CardHeader color="yellow">
            <h3 className="text-base sm:text-lg font-bold text-black">
              Note from Alex
            </h3>
          </CardHeader>
          <CardContent>
            <p className="text-xs sm:text-sm text-gray-700 leading-relaxed">
              {adminNote}
            </p>
            {lastUpdated && (
              <div className="mt-3 sm:mt-4 pt-3 sm:pt-4 border-t-2 border-black">
                <div className="text-xs text-gray-500">Last Updated</div>
                <div className="text-xs sm:text-sm font-bold text-black mt-1">
                  {lastUpdated}
                </div>
              </div>
            )}
          </CardContent>
        </Card>
      )}

      {/* Action Buttons */}
      <div className="space-y-2">
        {onRequestMeeting && (
          <Button
            variant="primary"
            className="w-full bg-gradient-to-r from-blue-400 to-purple-600 text-sm sm:text-base"
            onClick={onRequestMeeting}
          >
            Request Meeting
          </Button>
        )}
        {onAskQuestion && (
          <Button
            variant="outline"
            className="w-full text-sm sm:text-base"
            onClick={onAskQuestion}
          >
            Ask Question
          </Button>
        )}
      </div>
    </div>
  );
}
